// src/components/site/NavLink.tsx
import cx from "clsx";
import Link from "next/link";

type Props = {
  href: string;
  children: React.ReactNode;
  /** If false, mark active when pathname *startsWith* href (e.g., /legal) */
  exact?: boolean;
  className?: string;
};

export default function NavLink({ href, children, exact = true, className }: Props) {
  return (
    <Link
      href={href}
      prefetch={false}
      // data-* used by the client enhancer to set aria-current + font
      data-href={href}
      data-exact={exact ? "1" : "0"}
      className={cx("text-sm font-medium hover:underline underline-offset-4", className)}
    >
      {children}
    </Link>
  );
}
